import { createSelector } from 'reselect';

const driveEntidadesSelector = state => state.drive.entidades;
const driveCarpetaActualSelector = state => state.drive.currentDirectory;

export const entidadSeleccionadaSelector = createSelector(
  [driveEntidadesSelector, driveCarpetaActualSelector],
  (entidades, currentDirectory) => {
    const { tipoEntidad: { id } } = currentDirectory;
    if (id !== undefined && id !== null) {
      for (let index = 0; index < entidades.length; index += 1) {
        const entidad = entidades[index];
        const { id: entidadId } = entidad;
        if (parseInt(id, 10) === parseInt(entidadId, 10)) {
          return entidad;
        }
      }
    }
    return null;
  },
);
